import { data } from '../../svg/FormatListNumbered/data';
import { makeIcon } from '../makeIcon';

export const FormatListNumbered = makeIcon(data, 'format_list_numbered', 'FormatListNumbered');

export default FormatListNumbered;
